import { useMemo } from 'react'
import { Icon, type TIconProps } from '~/components/icon'
import { useInputMultiSelectContext } from '../../input-multi-select'
import type {
  InputMultiSelectIconProps,
  InputMultiSelectScopedProps,
} from '../../input-multi-select.types'

export function InputMultiSelectIcon({
  __scopeInputMultiSelect,
  color = 'colorTextNeutralDefault',
  ...props
}: InputMultiSelectScopedProps<InputMultiSelectIconProps>) {
  const { size, disabled, readonly } = useInputMultiSelectContext(
    'InputMultiSelectField',
    __scopeInputMultiSelect
  )

  const iconSize = useMemo(() => {
    const InputMultiSelectIconSizeMapper: Record<string, TIconProps['size']> = {
      md: 'extra-small',
      ml: 'small',
      lg: 'small',
      xl: 'small',
    }
    return InputMultiSelectIconSizeMapper?.[size!]
  }, [size])

  const iconColorMapping = (): TIconProps['color'] => {
    if (readonly) return 'colorTextNeutralReadonly'
    return disabled ? 'colorTextNeutralDisabled' : 'colorTextNeutralDefault'
  }

  return (
    <div className="flex items-center">
      <Icon {...props} color={iconColorMapping()} size={iconSize} />
    </div>
  )
}
